// extracted by mini-css-extract-plugin
export default {"container":"LocationScreen_container__YmJaX"};